




























































































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  defaultUpdateOrderMemoInfoItem,
  UpdateOrderMemoOrderInfoItem
} from '@/components/organisms/UpdateOrderMemoOrderInfo/index.type'
import { OrderIdMaxDigits } from '@/types'

@Component({
  components: {}
})
export default class UpdateOrderMemoOrderInfo extends ComponentVue {
  @Prop({
    type: Object,
    default: defaultUpdateOrderMemoInfoItem
  })
  item!: UpdateOrderMemoOrderInfoItem

  get orderId(): string {
    if (this.item.orderId !== 0) {
      return String(this.item.orderId).padStart(OrderIdMaxDigits, '0')
    }

    return ''
  }
}
